import { ConfirmationModal, ErrorModal } from "components/reusables";
import { Faculty } from "models";
import React, { useState } from "react";
import { Button, Card, Col, Row } from "react-bootstrap";
import Img from "react-cool-img";
import { useHistory } from "react-router-dom";
import { deleteFacultyStory } from "services/facultyService";
import genericAvatar from "assets/images/generic_avatar.jpg";
import { AddEditFacultyModal } from "components/reusables/AddEditModals/AddEditFacultyModal";
import { FacultySecondaryInfo } from "../../reusables/SecondaryInfo/FacultySecondaryInfo";

interface FacultyCardProps {
  facultyMember: Faculty;
}

export function FacultyCard({ facultyMember }: FacultyCardProps): JSX.Element {
  const [isShowingConfirmDelete, setIsShowingConfirmDelete] = useState(false);
  const [isShowingEditFacultyModal, setIsShowingEditFacultyModal] = useState(false);
  const [isDisplaying] = useState(facultyMember.display);
  const [error] = useState<Error | undefined>(undefined);
  const history = useHistory();

  return (
    <>
      <Row>
        <Col xs="auto" className="d-flex align-items-center p-0" />

        <Col>
          <Card style={{ opacity: isDisplaying ? 1 : 0.5 }}>
            <Card.Body>
              <Row>
                <Col xs={3} md={2} className="d-flex align-items-center">
                  <div className="img-square-container">
                    <Img
                      src={facultyMember.photoUrl || ""}
                      placeholder={genericAvatar}
                      alt={`${facultyMember.firstName} ${facultyMember.lastName}`}
                      width="100%"
                      loading="lazy"
                    />
                  </div>
                </Col>
                <Col className="d-flex align-items-center">
                  <div>
                    <h2>
                      {`${facultyMember.firstName} ${facultyMember.lastName}`}
                      {" (Faculty)"}
                    </h2>
                    <FacultySecondaryInfo facultyMember={facultyMember} />
                  </div>
                </Col>
                <Col xs="auto" className="d-flex align-items-center">
                  <div className="d-flex flex-column justify-content-center">
                    <Button
                      onClick={() =>
                        history.push(`map-view-admin/faculty-details/${facultyMember.id}`)
                      }
                      className="p-3"
                      variant="link"
                      size="lg"
                    >
                      Learn More
                      <i className="ml-2 fas fa-arrow-right" />
                    </Button>

                    <div className="buttons spaced-children">
                      <div className="buttons spaced-children">
                        <Button
                          variant="outline-success"
                          size="lg"
                          onClick={() => setIsShowingEditFacultyModal(true)}
                        >
                          Edit
                        </Button>
                      </div>
                      <Button
                        variant="outline-danger"
                        size="lg"
                        onClick={() => setIsShowingConfirmDelete(true)}
                      >
                        Delete
                      </Button>
                    </div>
                  </div>
                </Col>
              </Row>
            </Card.Body>
          </Card>
        </Col>
      </Row>

      <ConfirmationModal
        title="Delete Member Profile?"
        message="Are you sure you want to delete this department member profile? This action cannot be undone."
        confirmText="Delete"
        variant="danger"
        show={isShowingConfirmDelete}
        onConfirm={() => {
          return deleteFacultyStory(facultyMember.id).finally(() => {
            window.location.reload();
          });
        }}
        onHide={() => setIsShowingConfirmDelete(false)}
      />
      <AddEditFacultyModal
        show={isShowingEditFacultyModal}
        setShow={setIsShowingEditFacultyModal}
        currentFaculty={facultyMember}
      />
      <ErrorModal error={error} />
    </>
  );
}
